// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/reset.css'
import '../static/css/slick.css'
import '../static/css/style.css'
import '../static/css/style-rel.css'
import  BaiduMap  from  'vue-baidu-map'


import axios from 'axios'; // 引入axios
Vue.prototype.$axios = axios;

Vue.use(BaiduMap,   {  
    ak:   'lo2uaYkh8SaHWATGbIHED71XYTaAuSeE'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js